import { useConnectedUserDeclarationDetails } from "../ConnectedPersonnelDeclarationDetails"
import { Link } from "react-router-dom"

const Footer = () => {
     const context = useConnectedUserDeclarationDetails()
     return (
          <div className="mt-4">
               <div className="d-none d-sm-flex justify-content-between">
                    <div>
                         <Link to="/personnel/mes-activites/declarations " className={`btn btn-sm btn-light-primary me-2`}>
                              <i className={"fas fa-list-dots me-2 align-middle"} /> Retour aux déclarations
                         </Link>
                         <button type="button" className="btn btn-sm btn-light-primary me-3" onClick={() => context.setCurrentStepHeader("ddc")}>
                              <span className={"fas fa-arrow-left fs-3 me-1 align-middle"} /> Congés
                         </button>
                    </div>

                    <button
                         type="button"
                         className="btn btn-sm btn-primary"
                         onClick={() => {
                              context.setCurrentStepHeader(context.enCoursDeRectificationEnabledDepuisRecapitulatif ? "recap" : "ndf")
                              context.setEnCoursDeRectificationEnabledDepuisRecapitulatif(false)
                         }}
                    >
                         {context.enCoursDeRectificationEnabledDepuisRecapitulatif ? "Récapitulatif" : "Notes de frais"}
                         <span className={"fas fa-arrow-right fs-3 ms-1 align-middle"} />
                    </button>
               </div>

               <div className="d-flex d-sm-none flex-column">
                    <div className={"mb-3"}>
                         <button type="button" className="btn btn-sm btn-light-primary me-3" onClick={() => context.setCurrentStepHeader("ddc")}>
                              <span className={"fas fa-arrow-left fs-3 me-1 align-middle"} /> Congés
                         </button>
                         <button
                              type="button"
                              className="btn btn-sm btn-primary float-end"
                              onClick={() => {
                                   context.setCurrentStepHeader(context.enCoursDeRectificationEnabledDepuisRecapitulatif ? "recap" : "ndf")
                                   context.setEnCoursDeRectificationEnabledDepuisRecapitulatif(false)
                              }}
                         >
                              {context.enCoursDeRectificationEnabledDepuisRecapitulatif ? "Récapitulatif" : "Notes de frais"}
                              <span className={"fas fa-arrow-right fs-3 ms-1 align-middle"} />
                         </button>
                    </div>

                    <Link to="/personnel/mes-activites/declarations " className={`btn btn-sm btn-light-primary`}>
                         <span className={"fas fa-list-dots fs-1 me-3 align-middle"} /> Retour aux déclarations
                    </Link>
               </div>
          </div>
     )
}

export default Footer
